import type { BlockCMS } from '@/types'
import { getTranslate } from '@/utils/api-interceptors'
import Link from 'next/link'
import ImageOptimize from '../ImageOptimize'
interface ModuleBannerL2Type {
  data: BlockCMS
}
const ModuleBannerL2 = ({ data }: ModuleBannerL2Type) => {
  return (
    <section
      id={data._id}
      className={`${data?.type} ${
        data?.hideBot ? '' : 'pb-3'
      } px-2 scroll-mt-[150px]`}
    >
      <div className='grid w-full grid-cols-2 gap-3'>
        {data &&
          data.data.map((e, i) => {
            return (
              <Link
                href={e.path ? e.path : '/'}
                className='block w-full'
                key={i}
              >
                <ImageOptimize
                  src={e?.image || ''}
                  alt={getTranslate(e?.name) || data?.name || 'Banner khuyến mãi'}
                  width={416}
                  height={151}
                  className='h-auto w-full rounded'
                />
              </Link>
            )
          })}
      </div>
    </section>
  )
}

export default ModuleBannerL2
